import { render, staticRenderFns } from "./LandingPage.vue?vue&type=template&id=cfb8ae64"
import script from "./LandingPage.vue?vue&type=script&lang=ts"
export * from "./LandingPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports